<template>
  <div>
    <vx-card>
      <vs-table pagination max-items="10" search :data="policies">
        <template slot="header" vs-justify="flex-end">
          <router-link :to="{name: 'master-debt-restructure-policy-add'}">
            <vs-button radius color="primary" icon-pack="feather" icon="icon-plus"></vs-button>
          </router-link>
        </template>

        <template slot="thead">
          <vs-th sort-key="effectiveDate">{{
              $t("sections.master.dataForm.debtRestructurePolicy.effectiveDate")
            }}
          </vs-th>
          <vs-th sort-key="name">{{ $t("sections.master.dataForm.debtRestructurePolicy.name") }}</vs-th>
          <vs-th sort-key="description">{{ $t("sections.master.dataForm.debtRestructurePolicy.description") }}</vs-th>
          <vs-th sort-key="status">{{ $t("sections.master.dataForm.debtRestructurePolicy.measureCount") }}</vs-th>
          <vs-th sort-key="status">{{ $t("sections.master.dataForm.debtRestructurePolicy.subMeasureCount") }}</vs-th>
          <vs-th sort-key="status">{{ $t("sections.master.dataForm.status") }}</vs-th>
          <vs-th sort-key="#" class="w-1/12"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(row, index) in data" :key="index">
            <vs-td>
              {{ row.effectiveDate | convYYYYMMDDToDDMMYYYY }}
            </vs-td>
            <vs-td>{{ row.name }}</vs-td>
            <vs-td>{{ row.description }}</vs-td>
            <vs-td>{{ row.measureCount }}</vs-td>
            <vs-td>{{ row.subMeasureCount }}</vs-td>
            <vs-td>
              <vs-chip :color="getStatusColor(row.status)">{{ row.status }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <router-link :to="{ name: 'master-debt-restructure-policy-edit', params: {id: row.id } }">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit"
                             v-if="pms ('MasterDebtRestructurePolicy', 'edit', 'b')"></vs-button>
                </router-link>
                <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash"
                           v-if="pms ('MasterDebtRestructurePolicy', 'delete', 'b')" @click="del(row.id);"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'

const {mapActions, mapState} = createNamespacedHelpers('Master')

export default {
  async created() {
    await this.getDebtRestructurePolicies()
  },
  computed: {
    ...mapState(['debtRestructurePolicies']),
    policies() {
      return this.debtRestructurePolicies
    }
  },
  methods: {
    ...mapActions(['getDebtRestructurePolicies', 'deleteDebtRestructurePolicy']),
    del(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this policy?',
        accept: () => this.deleteDebtRestructurePolicy({form: {id}, vm: this})
      })
    }
  }
}
</script>
